import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadClasswiseFS_PDF } from "./DownloadClasswiseFS_PDF";

const Pending_Fees = () => {

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  
  const [reportData, setReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);

    } catch (err) {
      console.error(err);
    }

  };

  /// To Populate Standard on change of Standard
  useEffect(() => {

    const fetchStandard = async () => {
      try {
        setDdlStds([]);
        if (selectedSection) {
          const std = await axios.get(`${BASE_URL}/api/ddl_standards`, {params: {p_Section_Id: selectedSection}});
          setDdlStds(std.data);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchStandard();

  }, [selectedSection]);

  const selectedStdName = ddlStds.find(std => std.std_id === Number(selectedStd))?.std_name || "";

  // Fetch report
  const handleRunReport = async () => {

    if (!selectedYear1 || selectedYear1 === '') {
      toast.error("Please select Academic Year.");
      return;      
    } else if (!selectedSection || selectedSection === '') {
      toast.error("Please select Section.");
      return;
    }

    try {

      setReportData([]);

      const res = await axios.get(`${BASE_URL}/api/rpt_classwise_fs`, {
        params: {
          p_year1: selectedYear1, 
          p_section_id: selectedSection, 
          p_std_id: selectedStd,
        }
      });

      if (res.data.length > 0) {
        setReportData(res.data);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  ///// Start : PDF Download
  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    downloadClasswiseFS_PDF({
        reportData,
        selectedYear1,
    });

  };
  //// End Pdf download

  const grandTotal = reportData.reduce(
    (sum, item) => sum + Number(item.pending_amount || 0),
    0
  );

  const groupedReport = reportData.reduce((acc, item) => {
    if (!acc[item.std_name]) {
      acc[item.std_name] = [];
    }

    acc[item.std_name].push(item);

    return acc;
  }, {});

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year 
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                      name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3} className="d-flex justify-content-end">

            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0} onClick={handleDownloadPDF} > Download PDF
            </Button>
            {/* <Button variant="success" className="ms-2"
              onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button> */}
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">

        {Object.keys(groupedReport).length > 0 ? (

          Object.keys(groupedReport).map((stdName) => {

            const stdData = groupedReport[stdName];

            const standardTotal = stdData.reduce(
              (sum, item) => sum + Number(item.yearly_amt || 0),
              0
            );

            return (

              <div key={stdName} className="mb-4">

                {/* Standard Heading */}
                <div className="mb-2">
                  <h6>
                    Standard : {stdName}
                    &nbsp;&nbsp; | &nbsp;&nbsp;
                    Academic Year : {selectedYear1} - {Number(selectedYear1) + 1}
                  </h6>
                </div>


                <div style={{ minHeight: '220px' }}  className="table-responsive">

                  <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">

                    <thead className="table-light">
                      <tr>
                        <th style={{ textAlign: 'left', width: '45%'  }}>Fee Components</th>
                        <th style={{ textAlign: 'center', width: '15%'  }}>Installment No</th>
                        <th style={{ textAlign: 'center', width: '10%'  }}>Fees Type</th>
                        <th style={{ textAlign: 'right', width: '15%'  }}>Fee Amount</th>
                        <th style={{ textAlign: 'right', width: '15%'  }}>Yearly Fee Amount</th>
                      </tr>
                    </thead>


                    <tbody>

                      {stdData.map((n) => (

                        <tr key={n.irn}>

                          <td style={{ textAlign: 'left' }}> {n.fee_desc} </td>
                          <td style={{ textAlign: 'center' }}> {n.install_no} </td>
                          <td style={{ textAlign: 'center' }}> {n.fee_type} </td>
                          <td style={{ textAlign: 'right' }}> {formatAmount(n.fee_amt)} </td>
                          <td style={{ textAlign: 'right' }}> {formatAmount(n.yearly_amt)} </td>
                        </tr>

                      ))}

                      {/* Standard Total */}
                      {/* <tr className="table-secondary fw-bold"> */}
                      <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>

                        <td colSpan="4" style={{ textAlign: 'left' }}> Total Yearly Fee Amount for {stdName}
                        </td>

                        <td style={{ textAlign: 'right' }}> {formatAmount(standardTotal)}
                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </div>

            );

          })

        ) : (

          <table className="table">
            <tbody>
              <tr>
                <td className="text-center">
                  No Entry found
                </td>
              </tr>
            </tbody>
          </table>

        )}

      </Card>

    </Container>
  );
};

export default Pending_Fees;
